import React, { Component } from 'react';
export default class Porfolio extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="portfolio">
        <div className="row">
          <div className="twelve columns collapsed">
            <h1>Confira alguns dos meus trabalhos.</h1>
            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
            {
              resumeData.portfolio && resumeData.portfolio.map((item)=>{
                return(
                <>
                  <div className="columns portfolio-item">
                    <div className="item-wrap">
                      <a href={"#modal-"+item.id}>
                        <img src={`${item.imgurl}`} className="item-img"/>
                        <div className="overlay">
                          <div className="portfolio-item-meta">
                            <h5>{item.name}</h5>
                            <p>{item.description}</p>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div id={"modal-"+item.id} className="popup-modal mfp-hide">
                    <img className="scale-with-grid" src={`${item.imgurl}`} alt="" />
                    <div className="description-box">
                      <h4>{item.name}</h4>
                      <p>{item.description}</p>
                    </div>
                    <div className="link-box">
                      <a href={`${item.url}`} target="_blank">Detalhes</a>
                      <a className="popup-modal-dismiss">Fechar</a>
                    </div>
                  </div>
                  </>
                )
              })
            }
            </div>
          </div>
        </div>
      </section>
    );
  }
}